import type { RuleDefinition } from './api';

export const ruleKeys = {
  all: ['rules'] as const,
  list: () => [...ruleKeys.all, 'list'] as const,
  recommended: () => [...ruleKeys.all, 'recommended'] as const,
  previews: () => [...ruleKeys.all, 'preview'] as const,
  preview: (definition: RuleDefinition, ruleId: string | undefined, days: number) =>
    [...ruleKeys.previews(), definition, ruleId, days] as const,
};
